// @ts-nocheck
import parseQueryString from "@insite/client-framework/Common/Utilities/parseQueryString";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import translate from "@insite/client-framework/Translate";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import Page from "@insite/mobius/Page";
import Typography from "@insite/mobius/Typography";
import StretchLayout from "@store/Library/Components/Toolkit/Layout/StretchLayout";
import { getStoreListState } from "@store/Framework/Store/Data/StoreLists/StoreListsSelector";
import loadStoreList from "@store/Framework/Store/Pages/StoreListsDetails/Handlers/LoadStoreList";
import React, { useEffect } from "react";
import { connect, ResolveThunks } from "react-redux";

const mapStateToProps = (state: ApplicationState) => {
    const location = getLocation(state);
    const parsedQuery = parseQueryString<{ listId?: string }>(location.search);
    const id = parsedQuery.listId;

    return {
        storeListId: id,
        storeListState: getStoreListState(state, id),
    };
};

const mapDispatchToProps = {
    loadStoreList,
};

type Props = ResolveThunks<typeof mapDispatchToProps> & ReturnType<typeof mapStateToProps> & PageProps;

const StoreListDetailPage = ({ id, storeListId, storeListState, loadStoreList }: Props) => {
    useEffect(() => {
        if (storeListId) {
            loadStoreList({ storeListId });
        }
    }, []);

    return (
        <Page>
            {storeListState.errorStatusCode === 404 ? (
                <Typography>{translate("Store List Not Available")}</Typography>
            ) : (
                <StretchLayout id={id} />
            )}
        </Page>
    );
};

const pageModule: PageModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(StoreListDetailPage),
    definition: {
        hasEditableUrlSegment: true,
        hasEditableTitle: true,
        fieldDefinitions: [],
        pageType: "System",
    },
};

export default pageModule;
